import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  InputNumberProps,
  InputRef,
  message,
  Modal,
  Row,
  Select,
  SelectProps,
  Space,
  Tooltip,
  //Space,
} from "antd";
import {
  DeleteTwoTone,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useClient } from "../../Context/ClientContext";
import ClientService from "../../Services/ClientService";
import { dayjs } from "../../../Utilities/dayjs";
import RequisitionService, {
  PriorityLevel,
} from "../../Services/Inventory/RequisitionService";
import ItemsService from "../../Services/ItemsService";
import AddItems from "../Purchase/AddItems";
import ItemLocationModel from "../ItemInventory/ItemLocationModel";
import OrganisationsService from "../../Services/Organisations/OrganisationsService";

const AddRequisition = ({
  open,
  setOpen,
  reqId,
  setTrigger,
  notification,
}: any) => {
  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [width, SetWidth] = React.useState<any>(window.innerWidth);
  const [companyList, setCompanyList] = useState<any[]>();
  const [itemList, setItemList] = useState<any[]>();
  const [locationList, setLocationList] = useState<any[]>();
  const [itemLength, setItemLength] = useState<number>(0);
  const [deptList, setDeptList] = React.useState<any>();
  const [deptModel, setDeptModel] = React.useState<boolean>(false);
  const [locModel, setLocModel] = React.useState<boolean>(false);
  const [itemLocationData, setItemLocationsData] = React.useState<any>({
    id: "",
  });

  const [openModel, setOpenModel] = React.useState<any>({
    type: "",
    param: {},
  });
  const { currentClient } = useClient();
  const [getData, setGetData] = React.useState<boolean>(false);

  React.useEffect(() => {
    ClientService?.getClientList(0, 15).then((res: any) => {
      if (res != null || res?.items?.length > 0) {
        setCompanyList(
          res?.items?.map((item: any) => ({
            value: item?.id,
            label: item?.bName,
          }))
        );
        form.setFieldValue("companies", currentClient?.id);
      } else {
        message.error(res?.message);
      }
    });

    ItemsService.getListItems(currentClient?.id!, 0, 0).then((res: any) => {
      if (res != null || res?.items?.length > 0) {
        console.log("itemList", res);
        setItemList(
          res?.items?.map((item: any) => ({
            value: item?._id,
            label: item?.Name,
          }))
        );
      } else {
        message.error(res?.message);
      }
    });
  }, [open, getData]);

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  React.useEffect(() => {
    getDepartmentList();
  }, [getData]);

  React.useEffect(() => {
    ItemsService.getItemLocationsList(currentClient?.id).then((res: any) => {
      if (res != null || res?.result?.length > 0) {
        console.log("locationList", res);
        setLocationList(
          res?.result?.map((loc: any) => ({
            value: loc?.id,
            label: loc?.itemLocationName,
          }))
        );
      } else {
        message.error(res?.message);
      }
    });
  }, [getData]);

  const getDepartmentList = async () => {
    let res = await OrganisationsService?.getDepttList(currentClient?.id!);
    if (res) {
      setDeptList(res);
    }
  };

  const handleChange = (value: string[]) => {
    console.log(`selected ${value}`);
  };

  useEffect(() => {
    if (open) {
      inputRef.current?.focus();
      if (reqId !== null) {
        RequisitionService.getRequisition(currentClient?.id!, reqId).then(
          (res: any) => {
            if (res?.result) {
              console.log("res", res);
              form.setFieldsValue({
                ...res?.result,
                companies: [res?.result?.companies],
                // departmentId: "",
                items: res?.result?.items.map((item: any) => ({
                  item: {
                    value: item.item?.id,
                    label: item.item?.name,
                    key: item.item?.id,
                  },
                  appliedQty: item?.appliedQty,
                  description: item?.description,
                  location: {
                    value: item?.location?.id,
                    label: item?.location?.name,
                    key: item?.location?.id,
                  },
                })),
                expectedDateToBeReceived: dayjs(
                  res?.result?.expectedDateToBeReceived
                ),
                priority: res?.result?.priority,
                specialRequest: res?.result?.specialRequest,
                status: res?.result?.status,
                date: dayjs(res?.result?.date),
              });
            }
          }
        );
      }
      console.log("form", form.getFieldsValue());
    }
  }, [open, reqId]);

  const addRequisitions = async () => {
    try {
      const val = await form.validateFields();
      setSaveButtonLoading(true);
      console.log("val", val);
      const requisitionData = {
        ...val,
        companies: [val.companies],
        // departmentId: "",
        items: val.items.map((item: any) => ({
          item: {
            id: item?.item?.value,
            name: item.item?.label,
          },
          appliedQty: item?.appliedQty,
          description: item?.description,
          location: {
            id: item?.location?.value,
            name: item?.location?.label,
          },
          departmentId: item?.departmentId,
        })),
        expectedDateToBeReceived: val.expectedDateToBeReceived.toISOString(),
        priority: val.priority,
        specialRequest: val.specialRequest,
        status: val.status,
        date: val.date.toISOString(),
      };
      console.log("dataaaa", requisitionData);

      const response = await RequisitionService.postRequisition(
        currentClient?.id!,
        requisitionData,
        reqId
      );
      if (response.status) {
        notification(
          "success",
          `Requisition ${reqId === null ? "Saved" : "Updated"} Successfully`
        );
        form.resetFields();
        setOpen(false);
        setTrigger((prev: any) => !prev);
      } else {
        notification("error", response.message);
      }
    } catch (error: any) {
      notification("error", "Failed to save requisition: " + error.message);
    } finally {
      setSaveButtonLoading(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        title={reqId === null ? "Add Requisition" : "Update Requisition"}
        onCancel={handleCancel}
        width={1000}
        maskClosable={false}
        //onOk={addRequisitions}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => {
                form.resetFields();
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => addRequisitions()}
              loading={saveButtonLoading}
              className="modelSaveButtonMargin"
            >
              {reqId ? "Update" : "Save"}
            </Button>
          </div>
        }
        closable={false}
      >
        <div>
          <Form
            style={{
              maxHeight: "70vh",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
            form={form}
            name="requisition"
            colon={false}
            initialValues={{
              items: [
                {
                  appliedQty: 1,
                },
              ],
              date: dayjs(),
            }}
            scrollToFirstError
            autoComplete="off"
            layout="vertical"
          >
            <Row
              gutter={14}
              style={{ justifyContent: width <= 375 ? "center" : "" }}
            >
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  name="companies"
                  className="inputBoxMb8 inputLabel33"
                  label="Company"
                >
                  <Select
                    mode="multiple"
                    disabled
                    style={{ width: "100%" }}
                    placeholder="Please select"
                    defaultValue={[]}
                    onChange={handleChange}
                    options={companyList}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Item Details */}

            <div>
              {/* //Form List */}
              {/* <Form.List name="itemDetail">
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Row>
                        <Col span={8}>
                          <Form.Item
                          name={[field.name, "itemName"]}
                            label="Item"
                            required={true}
                            key={field.key}
                          >
                            <Select
                              allowClear
                              style={{ width: "100%" }}
                              placeholder="Please select"
                              onChange={handleChange}
                              options={itemList}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name={[field.name, "qty"]}
                            label="Quantity"
                            required={true}
                            key={field.key}
                          >
                            <Input type="number" />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            name={[field.name, "description"]}
                            label="Description"
                            key={field.key}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        style={{ width: "60%" }}
                        icon={<PlusOutlined />}
                      >
                        Add field
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List> */}
              <Form.List name="items">
                {(fields, { add, remove }) => (
                  <>
                    <Divider
                      orientation="left"
                      orientationMargin="0"
                      className="dividertext"
                      style={{ marginTop: "11px", marginBottom: "11px" }}
                    >
                      <p style={{ fontWeight: 600 }}>Item Details</p>
                    </Divider>

                    {fields.map(({ key, name, ...restField }, index) => (
                      <>
                        <Row key={key} gutter={14}>
                          <Col lg={7} md={7} sm={12} xs={24}>
                            <Form.Item
                              name={[name, "item"]}
                              className="inputBoxMb8 inputLabel33"
                              label="Item"
                              rules={[
                                { required: true, message: "Please input!" },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{ width: "100%" }}
                                placeholder="Please select"
                                options={itemList}
                                onChange={() => add()}
                                labelInValue
                                dropdownRender={(itemsOption) => (
                                  <>
                                    {itemsOption}
                                    <Divider
                                      style={{
                                        margin: "5px 0px",
                                      }}
                                    />
                                    <Button
                                      style={{ width: "100%" }}
                                      icon={<PlusOutlined />}
                                      type="link"
                                      onClick={() => {
                                        setOpenModel({
                                          type: "addItem",
                                          param: { open: true },
                                        });
                                      }}
                                    >
                                      Add New Item
                                    </Button>
                                  </>
                                )}
                              />
                            </Form.Item>
                          </Col>
                          <Col lg={3} md={3} sm={12} xs={24}>
                            <Form.Item
                              name={[name, "appliedQty"]}
                              className="inputBoxMb8 inputLabel33"
                              label="Quantity"
                            >
                              <InputNumber min={1} max={10000} />
                            </Form.Item>
                          </Col>

                          <Col lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                              name={[name, "description"]}
                              className="inputBoxMb8 inputLabel33"
                              label="Description"
                            >
                              <Input.TextArea autoSize />
                            </Form.Item>
                          </Col>

                          <Col lg={6} md={6} sm={12} xs={24}>
                            <Form.Item
                              name={[name, "location"]}
                              className="inputBoxMb8 inputLabel33"
                              label="Location"
                            >
                              <Select
                                allowClear
                                style={{ width: "100%" }}
                                placeholder="Please select"
                                options={locationList}
                                labelInValue
                                dropdownRender={(itemsOption) => (
                                  <>
                                    {itemsOption}
                                    <Divider
                                      style={{
                                        margin: "5px 0px",
                                      }}
                                    />
                                    <Button
                                      style={{ width: "100%" }}
                                      icon={<PlusOutlined />}
                                      type="link"
                                      onClick={() => setLocModel(true)}
                                    >
                                      Add New Location
                                    </Button>
                                  </>
                                )}
                              />
                            </Form.Item>
                          </Col>
                          <Col lg={7} md={7} sm={12} xs={24}>
                            <Form.Item
                              name={[name, "departmentId"]}
                              className="inputBoxMb8 inputLabel33"
                              label="Departments"

                              //rules={[{ required: true, message: 'Please input!' }]}
                            >
                              <Select
                                mode="multiple"
                                allowClear
                                style={{ width: "100%" }}
                                placeholder="Please select"
                                defaultValue={[]}
                                onChange={handleChange}
                                options={deptList?.map((value: any) => ({
                                  value: value?.id,
                                  label: value?.depttName,
                                }))}
                                dropdownRender={(itemsOption) => (
                                  <>
                                    {itemsOption}
                                    <Divider
                                      style={{
                                        margin: "5px 0px",
                                      }}
                                    />
                                    <Button
                                      style={{ width: "100%" }}
                                      icon={<PlusOutlined />}
                                      type="link"
                                      onClick={() => setDeptModel(true)}
                                    >
                                      Add New Department
                                    </Button>
                                  </>
                                )}
                              />
                            </Form.Item>
                          </Col>
                          <Col lg={3} md={3} sm={12} xs={24}>
                            <Button
                              disabled={fields.length === 1}
                              style={{
                                padding: "0px",
                                borderColor: "#fff",
                                boxShadow: "none",
                                marginTop: "20px",
                              }}
                              onClick={() => {
                                remove(name);
                              }}
                            >
                              <DeleteTwoTone
                                className="ca-delete-btn"
                                twoToneColor="#ff879d"
                              />
                            </Button>
                          </Col>
                          <Divider style={{ margin: "7px" }} />
                        </Row>
                      </>
                    ))}
                    <Form.Item className="inputBoxMb">
                      <Row key={"add Item Detail"}>
                        <Col>
                          <Button
                            type="link"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Item Details
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <Divider
                orientation="left"
                orientationMargin="0"
                className="divider"
                style={{ marginTop: "11px", marginBottom: "11px" }}
              ></Divider>
              <Row
                gutter={14}
                style={{ justifyContent: width <= 375 ? "center" : "" }}
              >
                <Col lg={5} md={5} sm={12} xs={24}>
                  <Form.Item
                    name="date"
                    className="inputBoxMb8 inputLabel33"
                    label="Current Date"
                  >
                    <DatePicker disabled format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
                <Col lg={5} md={5} sm={12} xs={24}>
                  <Form.Item
                    name="expectedDateToBeReceived"
                    className="inputBoxMb8 inputLabel33"
                    label="Expected Delivery Date"
                    rules={[{ required: true, message: "Please input!" }]}
                  >
                    <DatePicker
                      disabledDate={(current) => current.isBefore(dayjs())}
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col lg={5} md={5} sm={12} xs={24}>
                  <Form.Item
                    name="priority"
                    className="inputBoxMb8 inputLabel33"
                    label="Priority"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Priority Level"
                      options={[
                        {
                          label: "Low",
                          value: PriorityLevel.Low,
                        },
                        {
                          label: "Medium",
                          value: PriorityLevel.Medium,
                        },
                        {
                          label: "High",
                          value: PriorityLevel.High,
                        },
                        {
                          label: "Unspecified",
                          value: PriorityLevel.Unspecified,
                        },
                      ]}
                      style={{
                        width: window.innerWidth <= 425 ? "226px" : " ",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col lg={9} md={9} sm={12} xs={24}>
                  <Form.Item
                    name="specialRequest"
                    className="inputBoxMb8 inputLabel33"
                    label="Special Note"
                  >
                    <Input.TextArea
                      autoSize
                      onChange={() => {
                        console.log("form", form.getFieldsValue());
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </Modal>

      {openModel.type === "addItem" && (
        <AddItems
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          // id={openModel?.param.id}
          // setTrigger={setTrigger((x) => !x)}
          setTrigger={setGetData}
        />
      )}

      {/* {deptModel && (
        <AddDepttModel
          open={true}
          data={{}}
          onCancel={() => setDeptModel(false)}
          setTrigger={setGetData}
        />
      )} */}

      {locModel && (
        <ItemLocationModel
          open={true}
          data={itemLocationData}
          onCancel={() => setLocModel(false)}
          setTrigger={setGetData}
        />
      )}
    </>
  );
};

export default AddRequisition;
